import Axios from "axios";

export default {
  async login(identifier, password, captchaUserResponse) {
    return await Axios.post("/api/authentication/login", {
      identifier,
      password,
      captchaUserResponse,
    }).then((response) => response);
  },
  async logout() {
    await Axios.delete("api/authentication/logout");
  },
  async ping() {
    return await Axios.get("/api/authentication/ping").then((response) => response);
  },
  async requestPasswordReset(email, captchaUserResponse, resetPasswordUrl) {
    return await Axios.post("/api/authentication/request-password-reset", {
      email,
      captchaUserResponse,
      resetPasswordUrl,
    }).then((response) => response);
  },
  /**
   * Vérifie que la demande de réinitialisation est encore valide.
   * @param {Guid} requestId Identifiant de la demande de réinitialisation de mot de passe.
   * @returns Promise
   */
  async checkRequestPasswordReset(requestId) {
    return await Axios.post("/api/authentication/check-request-password-reset", {
      requestId,
    }).then((response) => response);
  },
  /**
   * Réinitiale le mot de passe du compte utilisateur.
   * @param {Guid} requestId Identiifiant de la demande de réinitialisation de mot de passe
   * @param {String} password mot de passe
   * @param {String} confirmPassword mot de passe de confirmation
   * @returns Promise
   */
  async resetPassword(requestId, password, confirmPassword) {
    return await Axios.post("/api/authentication/reset-password", {
      requestId,
      password,
      confirmPassword,
    }).then((response) => response);
  },
};
